<yo-generic-datagrid-pn [pathFileHelp]="pathFile" [service]="secteursSvc"></yo-generic-datagrid-pn>
